/**
 * Los roles se declaran aquí y no se importan de Prisma porque este paquete
 * también lo consume el navegador, que no puede cargar el cliente de Prisma.
 * Los valores coinciden exactamente con el enum `RolUsuario` del esquema; hay
 * una prueba que lo verifica del lado del API.
 */
export const ROLES = [
  'SUPER_ADMIN',
  'ADMIN_CONDOMINIO',
  'JEFE_SEGURIDAD',
  'GUARDIA',
  'RESIDENTE',
] as const;

export type Rol = (typeof ROLES)[number];

/**
 * No hay jerarquía lineal de permisos: un residente no es "menos" que un
 * guardia, es otra cosa. Por eso los guards enumeran roles explícitamente en
 * vez de comparar niveles. Estos conjuntos son los agrupamientos que se
 * repiten.
 */

/** Configuran el condominio: padrón, topología, dispositivos, reportes. */
export const ROLES_ADMINISTRATIVOS: readonly Rol[] = [
  'SUPER_ADMIN',
  'ADMIN_CONDOMINIO',
  'JEFE_SEGURIDAD',
];

/** Operan la caseta: turnos, registro de visitas, apertura manual. */
export const ROLES_CASETA: readonly Rol[] = [
  'SUPER_ADMIN',
  'ADMIN_CONDOMINIO',
  'JEFE_SEGURIDAD',
  'GUARDIA',
];

export function esAdministrativo(rol: Rol): boolean {
  return ROLES_ADMINISTRATIVOS.includes(rol);
}

export function operaCaseta(rol: Rol): boolean {
  return ROLES_CASETA.includes(rol);
}

/**
 * El super admin es de Kodica, no de un condominio: es el único que puede
 * cruzar de un condominio a otro. Todos los demás quedan encerrados en el
 * suyo, y eso se verifica en cada consulta, no solo en el menú.
 */
export function puedeCruzarCondominios(rol: Rol): boolean {
  return rol === 'SUPER_ADMIN';
}
